try {
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');

} catch (e) {
    console.error("Cannot load jquery...", e);
}

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'

import App from './App'
import Overlay from './components/Overlay'

Vue.use(VueRouter)
Vue.config.productionTip = false

/*
Router configuration
 */
const router = new VueRouter({
    mode: 'history',
    /*
    We just add one route
     */
    routes: [{
        // Wildcard path
        path: '*',
        // Specify the component to be rendered for this route
        component: Overlay,
        // Inject  props based on route.query values (our query parameters!)
        props: (route) => ({
            left: route.query.left,
            right: route.query.right
        })
    }]
});

/* eslint-disable no-new */
new Vue({
    router,
    el: '#app',
    data: {
        userdata: {},
        left: '',
        right: '',
    },
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js